export const VERSION_APP = 'v0.0.1' as const

export const STATUS_VALIDATIONS = {
  CREADA: 'CREADA',
  EN_PROCESO: 'EN_PROCESO',
  EXITOSA: 'EXITOSA',
  RECHAZADA: 'RECHAZADA',
  ANULADA: 'ANULADA',
}
